module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-present-2-sp_86fe635abeeba7f4e95f8b59ca0209a6.png";